// extracted by mini-css-extract-plugin
export default {"ResursTree":"tree_ResursTree__YkdVA","header":"tree_header__wKiYD","tree":"tree_tree__g47h2"};